<template v-if="this.user.loggedIn">
  <div class="container">
    <div v-if="message.success !== undefined">
      <div class="alert alert-success fixed-top text-center" role="alert">
        {{message.success}}
      </div>
    </div>
    <div v-if="message.error !== undefined">
      <div class="alert alert-danger fixed-top text-center" role="alert">
        {{message.error}}
      </div>
    </div>
    <p>Hier können vorgefertigte Antworten erstellt und automatische Antworten angepasst werden.</p>
    <div class="card p-2">
      <div class="p-3 text-center">
        <b-form-input                    
          id="title"
          type="email"
          class="form-control mb-2"
          placeholder="Vorlage Titel"
          name="title"
          value
          required
          autofocus
          v-model="title">
        </b-form-input>
        <b-form-textarea
          id="textarea"
          v-model="text"
          placeholder="Danke für deine Bewerbung..."
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </div>
      <b-button v-if="editMode" @click="editMode = false; title = null; text = null">Abbrechen</b-button>
      <b-button variant="primary" class="mt-4" @click="editMode ? updateResponse() : saveResponse()">
        <span v-if="editMode">Änderungen speichern</span>
        <span v-else>Erstellen</span>
      </b-button>
    </div>
    <span v-for="(item, index) in dataArray" :key="index">
      <b-list-group class="mt-3">
        <b-list-group-item>
          <!-- {{item}} -->
          <div class="d-flex" style="justify-content: space-between; align-items: center;">
            <h3>{{ item.title }}</h3>

            <div>
              <b-button variant="secondary" @click="enterEditMode(item.docId)">Bearbeiten</b-button>
              <b-button variant="danger" v-b-modal.modal-1 @click="id=item.docId">Löschen</b-button>
            </div>
          </div>
          <hr>
          <span v-html="item.text.replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
        </b-list-group-item>
      </b-list-group>
    </span>

  <b-modal id="modal-1" title="Löschen?" @ok="deleteMessage()">
    <p class="my-4" >Möchtest du die Antwortvorlage Löschen?</p>
  </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { query, collection, getDocs, addDoc, deleteDoc, doc, updateDoc } from "firebase/firestore"
import {firestore} from "../plugins/firebase";

export default {
  name: 'ResponseEditor',
  computed: {
    ...mapGetters({
      user: "user"
    })
  },

  data() {
    return {
      dataArray: undefined,
      absendenButton: false,
      message: {
          success: undefined,
          error: undefined
      },
      title: null,
      text: null,
      id: null,
      editMode: false
    }
  },
  methods: {
    async loadData(){
      const q = await query(collection(firestore, "responseSelection"));
      const querySnapshot = await getDocs(q);
      const tempData = {}
      querySnapshot.forEach((doc) => {
        tempData[doc.id] = doc.data()
        tempData[doc.id].docId = doc.id
      })
      this.dataArray = tempData
      this.dataArray = Object.entries(this.dataArray).sort((a, b) => {
        return a[1].title.localeCompare(b[1].title);
      }).reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
      }, {});
    },
    async saveResponse(){
      const data = {
        title: this.title,
        text: this.text
      }
      if(data.title && data.text){
          await addDoc(collection(firestore, "responseSelection"), data)
          .then(() => {
            this.message.success = 'Die Daten wurden erfolgreich gespeichert.'
            this.loadData();
            setTimeout(this.resetMessage, 3000)
            this.title = null
            this.text = null
          }).catch((error) => {
            this.message.error = 'Es ist ein Fehler aufgetreten.<br>'+error
            setTimeout(this.resetMessage, 3000)
          })
      } else {
        this.message.error = "Nicht alle Felder sind gefüllt.";
        setTimeout(this.resetMessage, 3000)
      }
    },
    resetMessage(){
      this.message.success = undefined
      this.message.error = undefined
    },
    enterEditMode(id){
      const messageToEdit = Object.values(this.dataArray).find(item => item.docId === id)
      this.title = messageToEdit.title
      this.text = messageToEdit.text
      this.id = id
      this.editMode = true
      const titleInput = document.getElementById('title')
      titleInput.focus()
      titleInput.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
    },
    updateResponse(){
      const docRef = doc(firestore, "responseSelection", this.id)
      try {
        updateDoc(docRef, {
          title: this.title,
          text: this.text
        }).then(() => {
          this.message.success = 'Die Daten wurden erfolgreich gespeichert.'
          this.loadData();
          setTimeout(this.resetMessage, 3000)
          this.title = null
          this.text = null
          this.id = null
          this.editMode = false
        }).catch((error) => {
          this.message.error = 'Es ist ein Fehler aufgetreten: ' + error
          setTimeout(this.resetMessage, 3000)
        })
      } catch (e) {
        this.message.error = 'Es ist ein Fehler aufgetreten: ' + e
        setTimeout(this.resetMessage, 3000)
      }
    },
    deleteMessage() {
      deleteDoc(doc(firestore, '/responseSelection', `${this.id}`))
      .then(()=>{
        this.loadData();
      })
    }
  },
  mounted(){
    this.loadData()
  }
}
</script>

<style scoped>
  tr {
    cursor: pointer;
  }
  #personImage { 
    position: absolute; 
    right: 0px; 
    top: 0px;  
    padding: 5px; 
    border: 1px solid #d3d3d3; 
    border-radius: 5px; 
    margin: 16px; 
    width: 240px;
  }
  .printOnly{
    display: none;
  }
  .alert{
    z-index: 999999999;
  }
</style>
